import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, mergeProps as _mergeProps, createCommentVNode as _createCommentVNode, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent } from "vue"

import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip';
    import { type Component, computed } from 'vue';
    import SidebarMenuButtonChild, {
        type SidebarMenuButtonProps,
    } from './SidebarMenuButtonChild.vue';
    import { useSidebar } from './utils';

    
export default /*@__PURE__*/_defineComponent({
  ...{
        inheritAttrs: false,
    },
  __name: 'SidebarMenuButton',
  props: {
    variant: { default: 'default' },
    size: { default: 'default' },
    isActive: { type: Boolean },
    class: {},
    asChild: { type: Boolean },
    as: { type: [String, Object, Function], default: 'button' },
    tooltip: {}
  },
  setup(__props: any) {

    

    const props = __props;

    const { isMobile, state } = useSidebar();

    const delegatedProps = computed(() => {
        const { tooltip, ...delegated } = props;
        return delegated;
    });

return (_ctx: any,_cache: any) => {
  return (!_ctx.tooltip)
    ? (_openBlock(), _createBlock(SidebarMenuButtonChild, _normalizeProps(_mergeProps({ key: 0 }, { ...delegatedProps.value, ..._ctx.$attrs })), {
        default: _withCtx(() => [
          _renderSlot(_ctx.$slots, "default")
        ]),
        _: 3
      }, 16))
    : (_openBlock(), _createBlock(_unref(Tooltip), { key: 1 }, {
        default: _withCtx(() => [
          _createVNode(_unref(TooltipTrigger), { "as-child": "" }, {
            default: _withCtx(() => [
              _createVNode(SidebarMenuButtonChild, _normalizeProps(_guardReactiveProps({ ...delegatedProps.value, ..._ctx.$attrs })), {
                default: _withCtx(() => [
                  _renderSlot(_ctx.$slots, "default")
                ]),
                _: 3
              }, 16)
            ]),
            _: 3
          }),
          _createVNode(_unref(TooltipContent), {
            side: "right",
            align: "center",
            hidden: _unref(state) !== 'collapsed' || _unref(isMobile)
          }, {
            default: _withCtx(() => [
              (typeof _ctx.tooltip === 'string')
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createTextVNode(_toDisplayString(_ctx.tooltip), 1)
                  ], 64))
                : (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.tooltip), { key: 1 }))
            ]),
            _: 1
          }, 8, ["hidden"])
        ]),
        _: 3
      }))
}
}

})